import { render, staticRenderFns } from "./cjActModal2.vue?vue&type=template&id=06e917b6&scoped=true"
import script from "./cjActModal2.vue?vue&type=script&lang=js"
export * from "./cjActModal2.vue?vue&type=script&lang=js"
import style0 from "./cjActModal2.vue?vue&type=style&index=0&id=06e917b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e917b6",
  null
  
)

export default component.exports